import React, { useState } from 'react';
import { 
    Box, Typography, Tabs, Tab, Paper, Snackbar, Alert
} from '@mui/material';
import RateCalendar from '../../components/RateCalendar';
import RatePlansTab from './RatePlansTab';
import OperationalFeesTab from './OperationalFeesTab';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
        </div>
    );
}

export default function PricingManagement() {
    const [tabValue, setTabValue] = useState(0);
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h4" fontWeight="bold">Rate & Pricing Management</Typography>
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: '#eaecf0', mb: 3 }}>
                <Tabs value={tabValue} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                    <Tab label="Rate Plans" />
                    <Tab label="Rate Calendar" />
                    <Tab label="Operational Fees" />
                </Tabs>
            </Box>
            
            <Box>
                <TabPanel value={tabValue} index={0}>
                    <RatePlansTab setNotification={setNotification} />
                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                    <RateCalendar />
                </TabPanel>

                <TabPanel value={tabValue} index={2}>
                    <OperationalFeesTab setNotification={setNotification} />
                </TabPanel>
            </Box>

            <Snackbar 
                open={notification.open} 
                autoHideDuration={4000} 
                onClose={() => setNotification({ ...notification, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert onClose={() => setNotification({ ...notification, open: false })} severity={notification.severity} sx={{ width: '100%' }}>
                    {notification.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
